// extracted by mini-css-extract-plugin
export default {"content":"Simple_content__f6P1s","header":"Simple_header__TvkTH","footer":"Simple_footer__mT+ix"};